<div class="dialog dialog--small">
  <div>
    <div class="dialog__header">
      @if (!editMode()) {
        <h3 class="dialog__title">
          {{ "Dialog.IPP.LinkedTo" | translate }}&nbsp;<span class="dialog__title-light">{{
            data.prefix.description
          }}</span>
        </h3>
      } @else {
        <h3 class="dialog__title">{{ "Selfservice.LinkToService" | translate }}</h3>
      }
      <svg-icon src="assets/images/icons/x.svg" class="dialog__close" (click)="closeDialog()"></svg-icon>
    </div>
    <div class="affected-service-item__wrapper">
      @for (service of linkedServices(); track $index; let i = $index) {
        <div>
          <affected-service [service]="service" [linkState]="editAction()" (linkActivated)="closeDialog(true)" />
        </div>
      }
    </div>
  </div>
</div>
